import { PATHS } from '@shared/constants';

// True when the current page is the consent-callback route. Unlike isConsentPopupWindow this doesn't
// rely on window.name / window.opener: both can be gone by the time the popup lands back here (we
// null popup.opener ourselves, and browsers clear window.name on a cross-site navigation or a COOP
// browsing-context-group switch, e.g. through the MFA step of the consent page). The route never
// needs an access token, so app-wide auth side effects must stay out of it either way.
export const isConsentCallbackRoute = () =>
	typeof window !== 'undefined' && window.location.pathname === PATHS.callbacks.CONSENT;
